import { combineReducers } from 'redux';

import sessionData from './reducers/sessionData';
import standardViewData from './reducers/standardViewData';
import instructionViewData from './reducers/instructionViewData';
import practiceViewData from './reducers/practiceViewData';
import progressViewData from './reducers/progressViewData';

const shadesOfMeaningReducer = combineReducers({
  sessionData,
  standardViewData,
  instructionViewData,
  practiceViewData,
  progressViewData,
});

export default shadesOfMeaningReducer;
